import { styled } from '@mui/system';

export const DialogOptionsContents = styled('div')(() => ({
  display: 'flex',
  flexDirection: 'column',
}));

export const FormDialog = styled('form')(() => ({
  padding: '1rem',
}));
